import { render, staticRenderFns } from "./employeeBasicDetails.vue?vue&type=template&id=89fbabe6&scoped=true"
import script from "./employeeBasicDetails.vue?vue&type=script&lang=js"
export * from "./employeeBasicDetails.vue?vue&type=script&lang=js"
import style0 from "./employeeBasicDetails.vue?vue&type=style&index=0&id=89fbabe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fbabe6",
  null
  
)

export default component.exports